export const defaultConfig = {
  cookies: {
    currencyCookieName: '24orepro-vsf-currency',
    countryCookieName: '24orepro-vsf-country',
    localeCookieName: '24orepro-vsf-locale',
    cartCookieName: '24orepro-vsf-cart',
    customerCookieName: '24orepro-vsf-customer',
    storeCookieName: '24orepro-vsf-store',
    messageCookieName: '24orepro-vsf-message',
    categoryCookieName: 'vsf-category',
  },
  locale: undefined as undefined,
  country: undefined as undefined,
  currency: undefined as undefined,
} as const;
